import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebFeederFactory } from '@connections/web-feeder.factory';
import { SystemServiceErrorCodKeyEnum } from '@model/enum/system-services-error-msg';
import { ConfigService } from '@services/webFeeder/config.service';
import { Constants } from '@utils/constants';
import { Observable, catchError, finalize, map, mergeMap, of, throwError } from 'rxjs';
import { LogService } from '../core/services/log.service';
import { AppUtils } from './../utils/app.utils';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(private http: HttpClient, private configService: ConfigService, private httpPdf: HttpClient, private _logSvc: LogService) {}

  // newguidgen() {
  //   function id() {
  //     return Math.floor((1 + Math.random()) * 0x10000)
  //       .toString(16)
  //       .substring(1);
  //   }
  //   return id() + id() + '-' + id() + '-' + id() + '-' +
  //     id() + '-' + id() + id() + id();
  // }

  getHeaders(url?: string, isPdf?: boolean, isTokenUserMultiBroker?: boolean) {
    // console.log('\n\nHTTP SERVER >>> getHeaders - URL: ' + url);
    if (!this.configService.isLoginTypeWSO2()) {
      const token = !isTokenUserMultiBroker ? this.configService.getTokenApi() : this.configService.getUserMarketData().tknApi;
      if (WebFeederFactory.appComponent && WebFeederFactory.appComponent.setValueToken) {
        WebFeederFactory.appComponent.setValueToken(token);
      }
      let headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
        'Access-Control-Allow-Methods': 'POST, GET, PUT, DELETE',
      });
      // headers.append('x-source-request', 'FastTradeWeb');
      headers = headers.append('x-source-tracker-id', AppUtils.newguidgen());
      if (token !== '' && token !== null) {
        headers = headers.set('Authorization', 'Bearer ' + token);
      }
      if (this.configService.getUserIdentifier()) {
        headers = headers.append('user-identifier', this.configService.getUserIdentifier());
      }
      return headers;
    } else {
      const token = this.configService.getTokenApi();
      let headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      if (isPdf) {
        headers = headers.set('Accept', 'application/pdf');
      }
      if (this.configService.getUserIdentifier()) {
        headers = headers.set('user-identifier', this.configService.getUserIdentifier());
      }
      // headers.append('x-source-request', 'FastTradeWeb');
      // headers.append('x-source-tracker-id', AppUtils.newguidgen());
      if (
        token !== '' &&
        token !== null &&
        (this.configService.isLoginTypeWSO2() || this.configService.isLoginTypeIAM()) &&
        url.indexOf('refresh_token') === -1 &&
        url.indexOf('revoke_token') === -1
      ) {
        headers = headers.set('Authorization', 'Bearer ' + token);
      }
      return headers;
    }
  }

  getHeadersWso2(noAuthentication?, isOrder?: boolean, isContentTypeJson?: boolean, signature?) {
    const token = this.configService.getTokenApi();
    if (WebFeederFactory.appComponent && WebFeederFactory.appComponent.setValueToken) {
      WebFeederFactory.appComponent.setValueToken(token);
    }
    let headers = new HttpHeaders();
    if (isContentTypeJson) {
      headers = headers.append('Content-Type', 'application/json');
    } else {
      headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');
    }
    headers = headers.append('Access-Control-Allow-Origin', '*');
    // headers.append('x-source-request', 'FastTradeWeb');
    // headers.append('x-source-tracker-id', apputils.newguidgen());
    if (token !== '' && token !== null) {
      headers = headers.append('Authorization', 'Bearer ' + token);
    }
    signature = signature || this.configService.getHbSignature();
    this.configService.writeLog('getHeadersWso2() signature: ', signature);
    if (isOrder) {
      this.configService.writeLog('getHeadersWso2() user_client_id: ', this.configService.getHbAccountId());
      headers = headers.append('signature', btoa(JSON.stringify({ user_client_id: +this.configService.getHbAccountId(), signature: signature })));
    }
    if (this.configService.getUserIdentifier()) {
      headers = headers.append('user-identifier', this.configService.getUserIdentifier());
    }
    return headers;
  }

  handleResponse(observable: Observable<Response | any>, url?: string, loader?: boolean): Observable<any> {
    let result = null;
    result = observable.pipe(
      mergeMap((res) => {
        return this.extractData(res);
      }),
      catchError((error: any) => this.onCatch(error)),
      catchError((error: any) => [throwError(() => error)]),
      finalize(() => {})
    );
    return result;
  }

  private async extractData(res: Response) {
    // const text = await res.text();
    let body: any = (await res.body) || res;

    // if (text.indexOf('Not Permit lastTime') < 0) {
    //   body = res.json();
    // }
    if (body && body.code && body.code === 23) {
      this.configService.writeLog('HTTP SERVICE > Code: ' + body.code + ' - Message: ' + body.message);
      this.configService.setBrokerAccount(null, Constants.COOKIE_HB_TYPE_MARKET_DATA);
      this.configService._authHbLoginType.next(3);
      this.configService.redirectExpireSession();
      return;
    } else if (body) {
      return body.Data || body;
    } else {
      return {};
    }
  }

  public doGet(api: string, path?: string, loader?: boolean, isTokenUserMultiBroker?: boolean): Observable<any> {
    let url = api.endsWith('/') ? api.slice(0, -1) : api;
    if (path) {
      url += path.startsWith('/') ? path : '/' + path;
    }
    const requestOptions = { headers: this.getHeaders(url, null, isTokenUserMultiBroker) };
    return this.handleResponse(this.http.get(url, requestOptions));
  }

  public doGetPdf(api: string, path?: string): Observable<any> {
    let url = api + '/';
    path !== undefined ? (url += path) : (url += '');
    if (!this.configService.isLoginTypeWSO2()) {
      const token = this.configService.getTokenApi();
      if (WebFeederFactory.appComponent && WebFeederFactory.appComponent.setValueToken) {
        WebFeederFactory.appComponent.setValueToken(token);
      }
      if (token !== '' && token !== null) {
        const HTTPOptions = {
          headers: new HttpHeaders({
            // 'Accept': 'application/pdf',
            // 'Content-Type': 'application/json',
            // 'Access-Control-Allow-Origin': '*',
            // 'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
            // 'Access-Control-Allow-Methods': 'POST, GET, PUT, DELETE',
            Authorization: 'Bearer ' + token,
          }),
          responseType: 'blob' as 'json',
        };
        return this.httpPdf.get<any[]>(url, HTTPOptions).pipe(map((data) => data));
      } else {
        const HTTPOptions = {
          headers: new HttpHeaders({
            // 'Accept': 'application/pdf',
            // 'Content-Type': 'application/json',
            // 'Access-Control-Allow-Origin': '*',
            // 'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
            // 'Access-Control-Allow-Methods': 'POST, GET, PUT, DELETE'
          }),
          responseType: 'blob' as 'json',
        };
        return this.httpPdf.get<any[]>(url, HTTPOptions).pipe(map((data) => data));
      }
    } else {
      const requestOptions: any = {
        headers: this.getHeaders(url, true),
        responseType: 'blob',
      };
      return this.handleResponse(this.http.get(url, requestOptions));
      // const HTTPOptions = {
      //   headers: new HttpHeaders({
      //     'Accept': 'application/pdf',
      //     'Content-Type': 'application/json',
      //     'Access-Control-Allow-Origin': '*',
      //     'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
      //     'Access-Control-Allow-Methods': 'POST, GET, PUT, DELETE',
      //     'Authorization': 'Bearer ' + this.configService.getTokenApi()
      //   }),
      //   'responseType': 'blob' as 'json'
      // };
      // return this.httpPdf.get<any[]>(url, HTTPOptions).map(((data) => data));
    }
  }

  public doGetWso2(api: string, path?: string, loader?: boolean): Observable<any> {
    let url = api;
    path !== undefined ? (url += path) : (url += '');
    const requestOptions = { headers: this.getHeaders(url) };
    // this.configService.writeLog('doGet >>>>: ' + url);
    return this.handleResponse(this.http.get(url, requestOptions));
  }

  public doPost(api: string, path: string, params?: any, headerAuthentication?: boolean, loader?: boolean, isTokenUserMultiBroker?: boolean): Observable<any> {
    let url = '';
    if (!path || path === '' || path === null) {
      url = api;
    } else {
      url = api + '/' + path;
    }
    const requestOptions: any = {
      headers: this.getHeaders(url, null, isTokenUserMultiBroker),
      method: 'POST',
      observe: 'response',
    };
    // this.configService.writeLog('doPost >>>>: ' + url + '\nparans: ');
    // this.configService.writeLog(params);
    return this.handleResponse(this.http.post(url, params, requestOptions), url, loader);
  }

  public doPostWso2(api: string, path: string, params?: any, headerAuthentication?: boolean, loader?: boolean, isOrder?: boolean, isContentTypeJson?: boolean, signature?: string): Observable<any> {
    let url = '';
    if (!path || path === '' || path === null) {
      url = api;
    } else {
      url = api + '/' + path;
    }
    const requestOptions = {
      headers: this.getHeadersWso2(url, isOrder, isContentTypeJson, signature),
      method: 'POST',
    };
    // this.configService.writeLog('doPostWso2 >>>>: ' + url + '\nparans: ');
    // this.configService.writeLog(params);
    return this.handleResponse(this.http.post(url, params, requestOptions), url, loader);
  }

  public doPost2(api: string, path: string, params?: any, noAuthentication?: boolean, loader?: boolean): Observable<any> {
    const url = api + path;
    const headers = this.getHeadersPostWso2(noAuthentication);
    const requestOptions = {
      headers: headers,
      method: 'POST',
    };

    // this.configService.writeLog('doPost2 >>>>: ' + url + '\nparans: ');
    // this.configService.writeLog(params);
    return this.handleResponse(this.http.post(url, params, requestOptions), url, loader);
  }

  getHeadersPostWso2(noAuthentication?) {
    const token = this.configService.getTokenApi();
    if (WebFeederFactory.appComponent && WebFeederFactory.appComponent.setValueToken) {
      WebFeederFactory.appComponent.setValueToken(token);
    }
    let headers = new HttpHeaders();
    // headers = headers.append('Content-Type', 'application/json');
    // headers = headers.append('Access-Control-Allow-Origin', '*');
    // headers.append('x-source-request', 'FastTradeWeb');
    // headers.append('x-source-tracker-id', apputils.newguidgen());
    if (token && !noAuthentication) {
      headers = headers.append('Authorization', 'Bearer ' + token);
    }
    return headers;
  }

  public doPut(api: string, path: string, params?: any, loader?: boolean, isTokenUserMultiBroker?: boolean): Observable<any> {
    const url = api + '/' + path;
    const requestOptions = { headers: this.getHeaders(url, null, isTokenUserMultiBroker) };
    // this.configService.writeLog('doPut >>>>: ' + url + '\nparans: ');
    // this.configService.writeLog(params);
    return this.handleResponse(this.http.put(url, params, requestOptions), url, loader);
  }

  public doPatch(api: string, path: string, params?: any, loader?: boolean, isTokenUserMultiBroker?: boolean): Observable<any> {
    const url = api + '/' + path;
    const requestOptions = { headers: this.getHeaders(url, null, isTokenUserMultiBroker) };
    return this.handleResponse(this.http.patch(url, params, requestOptions), url, loader);
  }

  public doDelete(api: string, path: string, params: any, loader?: boolean, isTokenUserMultiBroker?: boolean): Observable<any> {
    const url = api + '/' + path;
    const urlParam = url + '/' + params;
    const requestOptions = { headers: this.getHeaders(url, null, isTokenUserMultiBroker) };
    // this.configService.writeLog('doDelete >>>>: ' + urlParam + '\nparans: ');
    // this.configService.writeLog(params);
    return this.handleResponse(this.http.delete(urlParam, requestOptions), urlParam, loader);
  }

  private onCatch(error: HttpErrorResponse) {
    this.errorsStatus(error);
    if ((this.configService.isLoginTypeWSO2() || this.configService.isLoginTypeIAM()) && (error.status === 400 || error.status === 422)) {
      return of(error);
    } else if (error['_body'] && error['_body'].type && error['_body'].type === 'error') {
      return throwError(() => error);
    } else if (error['_body'] && JSON.parse(error['_body'])) {
      return of(JSON.parse(error['_body']));
    }
    return throwError(() => error);
  }

  private errorsStatus(error) {
    this.configService.writeLog(error, 'HTTP SERVICE > errorsStatus: ');

    let errorMsg = `HTTP SERVICE > URL: ${error.url}  - errorsStatus: ${error.status} - body:  ${error.body}`;
    this._logSvc.error(errorMsg);

    if (error && (error.status === 110 || error.status === 401)) {
      this.configService.writeLog('HTTP SERVICE > URL: ' + error.url + ' - errorsStatus: ' + error.status + ' - body: ' + error.body);
      const errorDetail = error['_body'] && error['_body'].type !== 'application/xml' ? JSON.parse(error['_body']) : null;
      if (errorDetail && errorDetail.error_info && errorDetail.error_info.length > 0) {
        const errorCode = errorDetail.error_info.find((x) => x.message) ? errorDetail.error_info.find((x) => x.message).message : null;
        this.configService.redirectExpireSession(null, null, errorCode, SystemServiceErrorCodKeyEnum.unautorized);
      } else if (errorDetail && errorDetail.error && errorDetail.error_message) {
        return errorDetail;
      } else {
        this.configService.redirectExpireSession();
      }
    }
  }

  public doGetBlob(api: string, path?: string, loader?: boolean, responseType?: any): Observable<any> {
    let url = api + '/';
    path !== undefined ? (url += path) : (url += '');
    let requestOptions;
    if (responseType) {
      requestOptions = new requestOptions({
        responseType: responseType,
        headers: this.getHeadersWSO2(),
      });
    } else {
      requestOptions = { headers: this.getHeadersWSO2() };
    }
    return this.handleResponse(this.http.get(url, requestOptions));
  }

  getHeadersWSO2(noAuthentication?) {
    const token = this.configService.getTokenApi();
    if (WebFeederFactory.appComponent && WebFeederFactory.appComponent.setValueToken) {
      WebFeederFactory.appComponent.setValueToken(token);
    }
    const headers = new HttpHeaders();
    // headers.append('x-source-request', 'Fast-Trade-Web');
    // headers.append('x-source-tracker-id', AppUtils.newguidgen());
    // headers.append('Content-Type', 'application/x-www-form-urlencoded');
    // headers.append('Access-Control-Allow-Origin', '*');
    if (token && !noAuthentication) {
      headers.append('Authorization', 'Bearer ' + token);
      // TODO: REMOÇÃO DE RENOVAÇÃO DO TOKEN AUTOMATICA ESPERANDO VALIDAÇÃO
      // this.autoLogout.refresh();
    }
    if (this.configService.getUserIdentifier()) {
      headers.append('user-identifier', this.configService.getUserIdentifier());
    }
    return headers;
  }
}
